import { render, staticRenderFns } from "./UnlockCode.vue?vue&type=template&id=6d130890&scoped=true&"
import script from "./UnlockCode.vue?vue&type=script&lang=ts&"
export * from "./UnlockCode.vue?vue&type=script&lang=ts&"
import style0 from "./UnlockCode.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UnlockCode.vue?vue&type=style&index=1&id=6d130890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d130890",
  null
  
)

export default component.exports